import { useStore } from '@kundinos/nanostores/react';

import { currentParametersStore } from './stores';

function useCurrentParameters() {
  return useStore(currentParametersStore);
}

export default useCurrentParameters;
